// gzip/base64-Nutzlasten aus Agent-Antworten (`logs_pull`, `backup`) im Browser
// auspacken bzw. speichern. Ein Ort für beides — Logs und Backup brauchen es.

function bytesFromB64(b64: string) {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

/** gzip+base64 → Text. Wirft, wenn der Browser kein DecompressionStream hat. */
export async function gunzipB64(b64: string): Promise<string> {
  if (typeof DecompressionStream === "undefined") {
    throw new Error("Dieser Browser kann kein gzip entpacken.");
  }
  const stream = new Blob([bytesFromB64(b64)])
    .stream()
    .pipeThrough(new DecompressionStream("gzip"));
  return await new Response(stream).text();
}

/** base64-Nutzlast als Datei anbieten (Fallback, wenn Entpacken nicht geht). */
export function downloadB64(b64: string, name: string, type = "application/gzip") {
  const url = URL.createObjectURL(new Blob([bytesFromB64(b64)], { type }));
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  URL.revokeObjectURL(url);
}
